// extracted by mini-css-extract-plugin
export default {"textFieldContainer":"_3c0Tj","label":"_2pruS","BoxSelectionOption":"rcOM0","boxSelectionOption":"rcOM0","BoxSelectionOptionMobile":"_1fniJ","boxSelectionOptionMobile":"_1fniJ"};